/* eslint-disable import/no-extraneous-dependencies */
import React from 'react';
import Helmet from 'react-helmet';
/* eslint-enable import/no-extraneous-dependencies */

import Hero from '../../components/hero';
import PostListingCard from '../../components/PostListingCard';

import styles from '../../pageComponents/card.module.css';

export default function Index({ data }) {
  const { edges: posts } = data.allMarkdownRemark ? data.allMarkdownRemark : { edges: [] };
  return ([
    <Helmet key="blogListingHelmet" title="Our Thoughts" />,
    <Hero color="purple" gradient key="projectListingHero">
      Our Projects
    </Hero>,
    <div key="blogListingContent" className={styles.singleCard}>
      {posts
        .filter(post => post.node.frontmatter.title.length > 0)
        .map(({ node: post }, index) => (
          <PostListingCard key={post.frontmatter.title} post={post} index={index} color="purple" />
        ))}
    </div>,
  ]);
}

export const pageQuery = graphql`
  query ProjectIndexQuery {
    allMarkdownRemark(
      filter: { frontmatter: { type: { eq: "project" }, published: {eq: true} } }
      sort: { order: DESC, fields: [frontmatter___date] }
    ) {
      edges {
        node {
          excerpt(pruneLength: 250)
          id
          frontmatter {
            title
            date(formatString: "MMMM DD, YYYY")
            path
            tags
            description
          }
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/pages/projects/index.jsx